module.exports = __webpack_public_path__ + "static/media/valor5.89ac8ef3.png";